import { useState, useEffect } from 'react';

export const useOrderSelection = (ordersData, filter, channelFilter, page, setPage) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [invoiceKey, setInvoiceKey] = useState(null);

  const orders = ordersData?.orders || [];
  const pagination = {
    current_page: ordersData?.currentPage || 1,
    total_pages: ordersData?.totalPages || 1,
    total_items: ordersData?.total || 0,
    items_per_page: 10,
    has_next: (ordersData?.currentPage || 1) < (ordersData?.totalPages || 1),
    has_prev: (ordersData?.currentPage || 1) > 1,
  };

  useEffect(() => {
    setPage(0);
  }, [filter, channelFilter, setPage]);

  const handlePrevPage = () => {
    if (pagination.has_prev) {
      setPage((p) => p - 1);
    }
  };

  const handleNextPage = () => {
    if (pagination.has_next) {
      setPage((p) => p + 1);
    }
  };

  const handleSelectOrder = (order, invoiceError, refetchInvoiceData) => {
    if (selectedOrder?._id === order._id && invoiceError) {
      refetchInvoiceData();
      return;
    }

    setSelectedOrder(order);
    if (order.channel === "SHOPEE") {
      setInvoiceKey(order._id);
    } else {
      setInvoiceKey(order.chave_acesso);
    }
  };

  const selectNextOrder = () => {
    if (selectedOrder && selectedOrder.channel === "SHOPEE") {
      const currentIdx = orders.findIndex((o) => o._id === selectedOrder._id);
      if (currentIdx !== -1 && currentIdx < orders.length - 1) {
        setSelectedOrder(orders[currentIdx + 1]);
      }
    }
  };

  return {
    selectedOrder,
    setSelectedOrder,
    invoiceKey,
    setInvoiceKey,
    orders,
    pagination,
    handlePrevPage,
    handleNextPage,
    handleSelectOrder,
    selectNextOrder,
  };
};